import { authenticatedPatch } from '../../../api/request';

export const updatePassword = (data, onFail) => {
    return authenticatedPatch(`/web-admin-data/password`, onFail, data);
};
